import PubSub from "underpub-js";

var ModalSlide = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ModalSlide',
	};

	$.extend(true, this.options, options);

};

ModalSlide.prototype.init = function() {

	var self = this;

};

export default ModalSlide;
